<template>
  <v-app>
    <v-app-bar app>
      <SiteLogo></SiteLogo>
      <v-spacer></v-spacer>
      <div v-if="auth.Session && auth.Session.token" class="d-sm-none">
        <v-dialog
          v-model="dialogAccount"
          fullscreen
          hide-overlay
          transition="scroll-x-reverse-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              v-bind="attrs"
              v-on="on"
              color="orange"
              size="36"
            >
              <span class="white--text text-h6">{{
                auth.User.name.charAt(0).toUpperCase()
              }}</span></v-avatar
            >
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Account</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="dialogAccount = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="black" size="36">
                    <span class="white--text text-h6">{{
                      auth.User.name.charAt(0).toUpperCase()
                    }}</span></v-avatar
                  >
                </v-list-item-avatar>
                <v-list-item-title>{{ auth.User.name }}</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
              :to="{ name: 'Page'+type+'Dashboard' }"
                @click="dialogAccount = false"
              >
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item :to="{ name: 'PageMainLogout' }">
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item>
              <v-divider v-if="plan && plan.isAutoRenewal && plan.stripeSubscriptionId"></v-divider>
              <v-list-item v-if="plan && plan.isAutoRenewal && plan.stripeSubscriptionId" @click="showCancelConfirmation">
                <v-list-item-title class="red--text">Cancel Subscription</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>
      </div>
      <div v-if="auth.Session && auth.Session.token" class="d-none d-sm-flex">
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                v-bind="attrs"
                v-on="on"
                color="orange"
                size="36"
              >
                <span class="white--text text-h6">{{
                  auth.User.name.charAt(0).toUpperCase()
                }}</span></v-avatar
              >
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="primary" size="36">
                    <span class="white--text text-h6">{{
                      auth.User.name.charAt(0).toUpperCase()
                    }}</span></v-avatar
                  >
                </v-list-item-avatar>
                <v-list-item-title>{{ auth.User.name }}</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                v-if="type"
                :to="{ name: 'Page'+type+'Dashboard' }"
                  @click="dialogAccount = false"
                >
                  <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item>
              <v-divider></v-divider>
              <v-list-item :to="{ name: 'PageMainLogout' }">
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <!-- <div v-else>
        <v-btn outlined color="primary">LOG IN</v-btn>
      </div> -->
    </v-app-bar>
    <v-main class="orange lighten-3">
      <router-view :key="$route.fullPath" />
    </v-main>
    <!-- <div class="text-right">
      <AButtonShare></AButtonShare>
    </div> -->

    <!-- Cancel Subscription Confirmation Dialog -->
    <v-dialog v-model="cancelConfirmationDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          Cancel Subscription
        </v-card-title>
        <v-card-text>
          <p>Are you sure you want to cancel your subscription?</p>
          <p class="text--secondary">
            This action will cancel your current subscription plan. You will continue to have access until the end of your current billing period.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            text 
            @click="cancelConfirmationDialog = false"
            :disabled="cancelApi.isLoading"
          >
            Keep Subscription
          </v-btn>
          <v-btn 
            color="red" 
            dark
            @click="cancelSubscription"
            :loading="cancelApi.isLoading"
            :disabled="cancelApi.isLoading"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSiteMovedDialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="headline info white--text">
          <v-icon color="white" class="mr-2">mdi-truck-fast</v-icon>
          We’ve Moved
        </v-card-title>

        <v-card-text class="pt-5">
          <img
            class="mx-auto"
            :src="require('@/assets/ChallengeTitle.png')"
            width="100%"
          />
          
          <p class="text-body-1 mb-3">
            We’re excited to share that we now have a new website at <a href="https://math.hamochi.my" class="blue--text">https://math.hamochi.my</a>
          </p>

          <p class="text-body-2 mb-2">
            To join the latest challenge, please register on the new site. We look forward to seeing you there. 😊
          </p>

          <v-btn
            block
            color="info"
            dark
            large
            rounded
            href="https://math.hamochi.my"
            class="my-3"
          >
            Go to New Website
          </v-btn>
        </v-card-text>

        <v-card-actions v-if="debugMode">
          <v-spacer></v-spacer>
          <v-btn text @click="showSiteMovedDialog = false">
            Dismiss
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import SiteLogo from "@/components/SiteLogoV6";
import { mapState } from "vuex";
export default {
  computed: mapState({
    auth: (state) => state.auth.data,
    setting: (state) => state.setting.data,
  }),
  components: {
    SiteLogo,
  },
  data: () => ({
    showSiteMovedDialog: true,
    showMainMenu: false,
    type: null,
    showAccountMenu: false,
    minimised: false,
    dialog: false,
    dialogAccount: false,
    notifications: false,
    sound: true,
    widgets: false,
    debugMode: false,
    cancelConfirmationDialog: false,
    planApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    cancelApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    plan: null,
    snackbar: {
      show: false,
      message: '',
      color: 'success',
      timeout: 4000
    },
    menu:[
      {
        icon: "mdi-home",
        route: { name: "PageMainHome" },
      },
      {
        icon: "mdi-calendar-star",
        route: { name: "PageMainEvent" },
      },
      {
        icon: "mdi-cloud-question",
        route: { name: "PageMainDiscover" },
      },
      // {
      //   icon: "mdi-bullhorn",
      //   route: { name: "PageMainNews" },
      // },
      {
        type: "divider",
      },
      {
        icon: "mdi-earth",
        route: { name: "PageMainLogin" },
        isGuest: true,
      },
      {
        type: "divider",
      },
      {
        icon: "mdi-earth",
        route: { name: "PageMainLanguage" },
      },
      // {
      //   icon: "mdi-help",
      //   route: { name: "PageMainHelp" },
      // },
      // {
      //   type: "divider",
      // },
      // {
      //   icon: "mdi-currency-usd",
      //   route: { name: "PageMainSupportUs" },
      // },
    ],
  }),
  created() {
    this.planApi.method = "GET";
    this.planApi.url =
      this.$api.servers.sso + "/api/v1/" + this.$_getLocale() + "/backend/account/plan/myPlan";

    this.planApi.callbackReset = () => {
      this.planApi.isLoading = true;
      this.planApi.isError = false;
    };

    this.planApi.callbackError = (e) => {
      this.planApi.isLoading = false;
      this.planApi.isError = true;
      this.planApi.error = e;
    };

    this.planApi.callbackSuccess = (resp) => {
      this.planApi.isLoading = false;
      this.plan = resp.data;
    };

   
    this.cancelApi.method = "POST"; 
    this.cancelApi.url =
      this.$api.servers.sso + "/api/v1/" + this.$_getLocale() + "/backend/account/plan/cancel";

    this.cancelApi.callbackReset = () => {
      this.cancelApi.isLoading = true;
      this.cancelApi.isError = false;
    };

    this.cancelApi.callbackError = (e) => {
      this.cancelApi.isLoading = false;
      this.cancelApi.isError = true;
      this.cancelApi.error = e;
      this.cancelConfirmationDialog = false;
    };

    this.cancelApi.callbackSuccess = () => {
      this.cancelApi.isLoading = false;
      this.cancelConfirmationDialog = false;
      this.plan = null; 
    };

    //BOC:[type]
    if(this.auth && this.auth.Account.type){
      this.type = this.$_ucfirst(this.auth.Account.type);
    }
    //EOC
  },
  mounted(){
    if(this.$route.query.debug && this.$route.query.debug == '1'){
      this.$store.commit("updateSetting", {debug : true});
    }else if(this.$route.query.debug && this.$route.query.debug != '1') {
      this.$store.commit("updateSetting", {debug : false});
    }
    
    this.debugMode = this.setting.debug
    this.$store.commit("checkVerifiedMobile");
    this.setMaintenanceEndTime()
  },
  methods: {
    clickAccountMenu() {
      this.showMainMenu = false;
      this.showAccountMenu = !this.showAccountMenu;
    },
    clickMainMenu() {
      this.showAccountMenu = false;
      this.showMainMenu = !this.showMainMenu;
    },
    setMaintenanceEndTime() {
      const currentTime = this.$moment();
      const maintenanceStart = this.$moment().set({'hour':1,'minute':0,'second':0,'millisecond':0});
      const maintenanceEnd = this.$moment().set({'hour':23,'minute':0,'second':0,'millisecond':0});

      if (currentTime.isBetween(maintenanceStart, maintenanceEnd) || this.setting.debug) {
        return true
      } else{
        this.$router.push({name:'PageErrorUnderMaintenance'})
      }
    },
    showCancelConfirmation() {
      this.cancelConfirmationDialog = true;
      this.dialogAccount = false; // Close the account menu
    },
    cancelSubscription() {
      this.$api.fetch(this.cancelApi);
    },
  },
};
</script>
<style scoped>
.debug-badge {
  position: fixed;
  top: 0;
  left: 0;
  background-color: red;
  color: white;
  padding: 5px;
  font-size: 12px;
  z-index: 9999;
}
</style>